import { Controller } from "@hotwired/stimulus"
import CryptoJS from "crypto-js"

export default class extends Controller {
  static targets = ["revealButton", "noteContent", "title"]
  static values = {
    encryptedMessage: String,
    encryptedLabel: String,
    key: String,
    revealUrl: String
  }

  connect() {
    this.decryptLabel()
  }

  decryptLabel() {
    if (!this.hasTitleTarget) return
    if (!this.encryptedLabelValue || !this.keyValue) return

    try {
      const decrypted = CryptoJS.AES.decrypt(this.encryptedLabelValue, this.keyValue)
      const label = decrypted.toString(CryptoJS.enc.Utf8)
      if (label) {
        this.titleTarget.textContent = label
      }
    } catch (e) {
      // Invalid key or corrupted ciphertext — leave the default "Secure Note" placeholder.
    }
  }

  reveal(event) {
    event.preventDefault()
    fetch(this.revealUrlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json'
      },
      credentials: 'same-origin'
    })
    .then(data => {
      const decryptedMessage = CryptoJS.AES.decrypt(this.encryptedMessageValue, this.keyValue)
      const note = decryptedMessage.toString(CryptoJS.enc.Utf8)

      this.noteContentTarget.textContent = note
      this.noteContentTarget.style.display = 'block'
      this.revealButtonTarget.style.display = 'none'
    })
    .catch(error => console.error('Error:', error))
  }
}
